import { makeStyles } from "@material-ui/core/styles";

const useModernDialogStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow:
      theme.palette.type === "light"
        ? "0 8px 24px rgba(16, 24, 40, 0.12), 0 2px 8px rgba(16, 24, 40, 0.08)"
        : "0 8px 24px rgba(0, 0, 0, 0.4)",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(2),
      width: `calc(100% - ${theme.spacing(4)}px)`,
      maxWidth: "none",
    },
  },
  title: {
    fontWeight: 600,
    fontSize: "1.125rem",
    letterSpacing: "-0.01em",
    padding: theme.spacing(2.5, 3, 1.5),
  },
  content: {
    padding: theme.spacing(0, 3, 2),
    ...theme.scrollbarStyles,
  },
  contentDividers: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  actions: {
    padding: theme.spacing(2, 3, 2.5),
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
      "& > *": {
        width: "100%",
        margin: "0 !important",
      },
    },
  },
  bodyText: {
    lineHeight: 1.6,
    color: theme.palette.text.primary,
  },
  formRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  arrowDivider: {
    fontSize: "1.5rem",
    color: theme.palette.success.main,
    fontWeight: 700,
    flexShrink: 0,
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      transform: "rotate(90deg)",
    },
  },
  progressWrap: {
    textAlign: "center",
    padding: theme.spacing(2.5, 0),
  },
  progressRing: {
    marginBottom: theme.spacing(2),
  },
  cancelButton: {
    borderRadius: 8,
    minHeight: 40,
    padding: theme.spacing(1, 2.5),
  },
  confirmButton: {
    borderRadius: 8,
    minHeight: 40,
    padding: theme.spacing(1, 2.5),
    boxShadow: "none",
  },
}));

export default useModernDialogStyles;
